// Public privacy policy (shown at /privacy and linked from Google's consent
// screen), in Arabic. "{contact}" is replaced on the page.

export const PRIVACY_UPDATED = "2026-10-15";
export const PRIVACY_CONTACT = "tamheedramla@gmail.com";

export const PRIVACY_CONTENT = {
  title: "سياسة الخصوصية - نظام جمعية تمهيد",
  intro: "يُستعمل هذا النظام داخليًا لإدارة نشاطات جمعية تمهيد في الرملة. توضح هذه الصفحة ما نحفظه من معلومات، ولماذا، وكيف نحميها.",
  updated: "آخر تحديث",
  sections: [
    {
      heading: "ما المعلومات التي نحفظها",
      items: [
        "بيانات الطاقم والمستخدمين: الاسم، رقم الهوية، الهاتف، البريد الإلكتروني، الدور والصلاحيات.",
        "بيانات الطلاب: الاسم، رقم الهوية، تفاصيل التواصل مع الأهل، الصورة، الدروس والحضور.",
        "التقارير، ومعلومات المركبات والمقطورات: الرخص والتأمين والفحوصات ومستنداتها.",
        "الملفات التي يرفعها المستخدمون إلى قسم الملفات.",
      ],
    },
    {
      heading: "لماذا نستعمل المعلومات",
      items: [
        "لتشغيل نشاطات الجمعية فقط: إدارة الطلاب والحضور والدروس والتقارير والمركبات.",
        "لإرسال تنبيهات للإدارة عن مستندات المركبات التي يقترب انتهاؤها.",
        "لا نبيع المعلومات ولا نعرضها للإعلانات ولا نشاركها مع جهات خارجية إلا كما هو مذكور أدناه.",
      ],
    },
    {
      heading: "Google Drive",
      items: [
        "الصور والملفات تُحفظ في حساب Google Drive واحد تابع للجمعية.",
        "يطلب النظام الصلاحية drive.file فقط، أي أنه يصل إلى الملفات التي أنشأها النظام نفسه ولا يرى أي ملفات أخرى في الحساب.",
        "الملفات خاصة ولا تُنشأ لها روابط عامة؛ فتحها يتم من داخل النظام بعد فحص صلاحية المستخدم.",
        "يُستعمل عنوان البريد الإلكتروني للحساب المرتبط فقط لبيان الحساب المتصل.",
      ],
    },
    {
      heading: "خدمات أخرى نستعملها",
      items: [
        "قاعدة البيانات مستضافة لدى MongoDB Atlas.",
        "عند استعمال زر «قراءة مستند»، يُرسل المستند إلى خدمة Claude من Anthropic لاستخراج تفاصيل الرخصة أو التأمين فقط، والنتيجة تُعرض كاقتراح ولا تُحفظ إلا بموافقة المستخدم.",
        "رسائل البريد الإلكتروني للتنبيهات تُرسل عبر مزوّد البريد الخاص بالجمعية.",
      ],
    },
    {
      heading: "الحماية والوصول",
      items: [
        "الدخول إلى النظام بحساب شخصي فقط، وكل مستخدم يرى ما تسمح به صلاحياته.",
        "الاتصال مشفّر (HTTPS)، وكلمات المرور محفوظة بشكل مشفّر.",
        "ربط حساب Google Drive أو تغييره متاح لحساب النظام فقط.",
      ],
    },
    {
      heading: "حقوقك والتواصل",
      items: [
        "يمكنك طلب الاطلاع على معلوماتك أو تصحيحها أو حذفها.",
        "للأسئلة والطلبات: {contact}",
      ],
    },
  ],
};
